import React from 'react';
import { SchoolCardImg } from '../SchoolCardImg';
import hsSvg from '../../ui/Schools/hs.svg';
import msSvg from '../../ui/Schools/ms.svg';
import psSvg from '../../ui/Schools/ps.svg';

interface SchoolLevelSelectionProps {
  options: string[];
  onNext: (selectedType: string) => void;
  setSelectedSchoolLevel: (selectedSchoolLevel: string) => void;
}

const SchoolLevelSelection: React.FC<SchoolLevelSelectionProps> = ({ onNext, options, setSelectedSchoolLevel }) => {
  const handleSchoolSelect = (school: string) => {
    setSelectedSchoolLevel(school);
    onNext(school);
  };

  const imagesMap = {
    hs: hsSvg,
    ms: msSvg,
    ps: psSvg,
  };
  // Mappa delle opzioni con il testo da mostrare sulle card
  const optionTexts: { [key: string]: string } = {
    ps: 'Scuola Elementare',
    ms: 'Scuola Media',
    hs: 'Scuola Superiore',
    University: 'Università',
  };

  return (
    <div className="w-full bg-white rounded-lg sm:rounded-xl px-6 py-3 sm:p-6 lg:p-8 shadow-lg">
      <div className="text-center mb-4 sm:mb-6 lg:mb-8">
        <h2 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-black mb-1 sm:mb-2">
          Quale scuola frequenta tuo figlio?
        </h2>
      </div>

      <div className="flex flex-wrap justify-center gap-3 sm:gap-4 lg:gap-6 mb-4 sm:mb-6 lg:mb-8 max-w-4xl mx-auto">
        {['hs', 'ms', 'ps'].filter(level => options.includes(level)).map((option, index) => (
          <SchoolCardImg
            key={index}
            title={optionTexts[option] || option}
            onClick={() => handleSchoolSelect(option)}
            imageSrc={imagesMap[option]}
            disabled={option === 'University'}
          />
        ))}
      </div>
    </div>
  );
};

export default SchoolLevelSelection;
